import { useState } from 'react';
import { IComposableDashboardCollectionsContext, deleteDashbaordCollection } from 'wisestep-api';

import { success, failed } from '../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../utils/NotificationStore';

import { useComposableDashboardCollectionsContext } from './useComposableDashboardCollectionsContext';

const useDeleteCollection = () => {
  const { setDashboardCollections, selectedDashboardCollection, setSelectedCollectionByIndex } =
    useComposableDashboardCollectionsContext() as Required<IComposableDashboardCollectionsContext>;
  const [openDeleteDialog, setOpenDeleteDialog] = useState<boolean>(false);
  const setNotification = useNotificationStore((state) => state.setNotification);
  const onDeleteCollection = async () => {
    try {
      await deleteDashbaordCollection(selectedDashboardCollection.id ?? '');
      setDashboardCollections((prev) =>
        prev?.filter(({ id }) => id !== selectedDashboardCollection.id)
      );
      setSelectedCollectionByIndex(-1);
      setNotification(
        success(`Dashboard collection ${selectedDashboardCollection?.name ?? ''} has been Deleted`)
      );
    } catch {
      setNotification(failed('Failed to delete dashboard collection, Please try again !!'));
      setSelectedCollectionByIndex(-1);
    }
    setOpenDeleteDialog(false);
  };
  return { onDeleteCollection, setOpenDeleteDialog, openDeleteDialog };
};

export default useDeleteCollection;
